import { Record } from 'immutable';
import Hydrator from 'utils/Hydrator';

const CasesSummaryRecord = Record({
  approvedCases: null,
  approvedCasesCapital: null,
  approvedCasesPercentage: null,
  openCases: null,
  openCasesCapital: null,
  activeCases: null,
  activeCasesCapital: null,
  totalCases: null,
});

export default class CasesSummary extends CasesSummaryRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {};

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CasesSummary(hydrated);
  }

  get approvedCasesPercentage() {
    return Math.round(this.get('approvedCasesPercentage') * 100);
  }

  get restOfCasesPercentage() {
    return Math.round((1 - this.get('approvedCasesPercentage')) * 100);
  }

  get allTimeCapital() {
    return +this.openCasesCapital + +this.approvedCasesCapital;
  }
}
